import React, { PropsWithChildren } from "react";
import {tokenLogin} from "../api/AuthenticationEndpoints";
import {RR_STATUS} from "../constants/RRConstants";
import {AUTH_PAGE_PATH} from "../layouts/navigation/Navigator";
import {useNavigate} from 'react-router-dom';
import BackendRestClient, {HEADER_IDENTITY_KEY, NO_AUTHORIZED_IDENTITY} from "../api/BackendRestClient";
import {isEmpty} from 'lodash';


interface ICredentials {
    id?: number,
    account?: number,
    firstName?: string,
    lastName?: string,
    userName?: string,
    partyName?: string,
    salutation?: string,
    contactType?: string,
    email?: string,
    phone?: string,
    mobile?: string,
    comment?: string,
    role?: string,
    seenTC?: string,
    staff?: boolean,
    agent?: boolean,
    identity?: string,
    domain?: string,
    permissions?: string[]
}

type ContextProps = {
    credentials: ICredentials,
    authenticate: (credentials?: ICredentials) => void,
    hasPermission: (permission: string) => boolean
};


export const AuthorizedContext = React.createContext<ContextProps>({
    credentials: {},
    authenticate: () => {
    },
    hasPermission: () => false
});


const Provider: React.FC<PropsWithChildren> = ({children}) => {

    const navigate = useNavigate();
    const [credentials, setCredentials] = React.useState<ICredentials>({});

    const authenticate = (credentials) => {
        if (credentials && !isEmpty(credentials)) {
            BackendRestClient.defaults.headers[HEADER_IDENTITY_KEY] = credentials.identity;
        } else {
            BackendRestClient.defaults.headers[HEADER_IDENTITY_KEY] = NO_AUTHORIZED_IDENTITY;
        }
        setCredentials(credentials);
    };

    const hasPermission = (permission) => !!credentials.permissions?.includes(permission);

    React.useEffect(() => {
        tokenLogin().then(({data}) => {
            const {status, response} = data;
            if (status !== RR_STATUS.OK) {
                authenticate({});
                navigate(AUTH_PAGE_PATH);
            } else {
                authenticate(response);
            }
        });
    }, [navigate]);


    return <AuthorizedContext.Provider value={{
        credentials,
        authenticate,
        hasPermission
    }}>
        {children}
    </AuthorizedContext.Provider>
};

export const AuthorizedContextProvider = Provider;
